// extracted by mini-css-extract-plugin
export default {"ActivityDot":"webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesButton-module__ActivityDot"};